/* eslint-disable */
import React, { Component } from 'react';

class Image extends Component {

	constructor(props) {
		super(props);
		
		this.state = {
			src : this.props.src,
			className : this.props.className,
			isSrcBase64 : this.props.isSrcBase64
		};
		
	}
	
	componentDidMount() {		
	}
	
	componentWillUnmount() {
	}

	componentWillReceiveProps(nextProps) {
		this.setState({src:nextProps.src, className:nextProps.className});
	} 
	
	
	

	render() {
		var filePrefix = '';
		if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
			filePrefix = process.env.PUBLIC_URL
		} else {
			filePrefix = window.info.config.filepathname 
		}
		return (
			<React.Fragment>
				{(this.props.isSrcBase64 == null || this.props.isSrcBase64 == false) && ( 
					<img style={this.props.style} className={this.state.className} src={filePrefix+this.state.src}  alt=""  />
				)}

				{this.props.isSrcBase64 != null && this.props.isSrcBase64 == true && ( 
					<img style={this.props.style} className={this.state.className} src={this.state.src}  alt=""  />
				)}
			</React.Fragment>			
		);
	}
}


export default Image;